import { IArchiveService } from './archiveService.types'
import { http } from '@/shared/https'

export class ArchiveService implements IArchiveService {
createArchive(payload)
{
    return http.post(`api/ArchiveCall`, payload)
        .then((resp: any) => {
            if (resp.status >= 200 && resp.status < 300) {
                return resp.data;
            }
        });
}

getProgrammes()
{
    return http.get(`api/ArchiveCall/GetPrograms`)
    .then((resp: any) => {
        return resp.data;
    });
}
Archive(file: any)
{
        return http.post(`api/ArchiveCall/ArchiveImport/0`,file)
        .then((resp: any) => {
            return resp.data;
        });
}
updateArchive(payload,id)
{
    return http.put(`api/ArchiveCall/${id}`, payload)
        .then((resp: any) => {
            if (resp.status >= 200 && resp.status < 300) {
                return resp.data;
            }
        });
}
deleteArchive(id)
{
    return http.delete(`api/ArchiveCall/${id}`)
        .then((resp: any) => {
            if (resp.status >= 200 && resp.status < 300) {
                return resp.data;
            }
        });
}
getArchive()
{
    return http.get(`api/ArchiveCall/List`)
    .then((resp: any) => {
        return resp.data;
    });
}

getArchiveById(id)
{
    return http.get(`api/ArchiveCall/GetArchiveCallDetail/${id}`)
    .then((resp: any) => {
        return resp.data;
    });
}
getCurrencies()
{
    return http.get(`api/ArchiveCall/GetCurrencies`)
    .then((resp: any) => {
        return resp.data;
    });
}
getArchiveForPublic()
{
    return http.get(`api/ArchiveCall/GetforPublic`)
    .then((resp: any) => {
        return resp.data;
    });
}
}